<div class="card bg-card-new card-radius-x1 border-0" *ngIf="vouchers">
    <div class="card-header">
        <h5>{{"vouchers"|translate}}</h5>
    </div>
    <div class="card-divider"></div>
    <div class="card-table">
        <div class="table-responsive-sm">
            <table>
                <thead>
                <tr>
                    <th>{{"code"|translate}}</th>
                    <th>{{"amount"|translate}}</th>
                    <th>{{"avaiable_from"|translate}}</th>
                    <th>{{"available_to"|translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let voucher of vouchers">
                    <td>{{ voucher.code }}</td>
                    <td>{{ voucher.amount|currencyFormat}}</td>
                    <td>{{ voucher.availableFrom |date }}</td>
                    <td>{{ voucher.availableTo |date }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- <div class="card-divider"></div> -->
    <!-- <div class="card-footer">
        <app-pagination (pageChange)="updateOrdersList($event)"  [total]="paginationOrderCount"></app-pagination>
    </div> -->
</div>
